import React, { useEffect, useState } from 'react';


import ReactAudioPlayer from 'react-audio-player';

import LightBoxGallery from '../../../components/lightboxgallery';
import CloseButton from '../../../components/closebutton';
import APIRondas from '../../../services/APIRondas';
import {
  Container,
  SectionTop,
  Section,
  Value,
  Separator,
  ContainerPath,
  Content
} from './styles';
import { IOcorrencia } from '../../../@interfaces';
import moment from 'moment';
import { useTheme } from 'styled-components';
import Title from '../../../components/title';
import Subtitle from '../../../components/subtitle';
import Text from '../../../components/text';

const audio = ''

interface IProps {
  ocorrencia: IOcorrencia,
  close: () => void;
  show: boolean
}


interface IImages {
  src: string;
}


const OcorrenciaDetalhe: React.FC<IProps> = ({ ocorrencia, close, show }) => {

  const [images, setImages] = useState<IImages[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [audios, setAudios] = useState<string[]>([])

  const theme = useTheme();


  useEffect(() => {
    if (show) getAnexos();
    else {
      setImages([]);
      setAudios([])
    }
  }, [show, ocorrencia])




  async function getAnexos() {
    try {
      setLoading(true);

      const { listaArquivos } = ocorrencia;
      if (listaArquivos && listaArquivos.length > 0) {
        const response = await APIRondas.getAnexosOcorrencia({ Arquivos: listaArquivos });
        if (!response.error) {
          const _audios: string[] = [];
          const _imgs: any = [];

          if (response.listaArquivo && response.listaArquivo.length > 0) {
            const { listaArquivo } = response;

            for (const item of listaArquivo) {
              const conteudo = item.conteudo.split(`,`)[1]
              if (!detectMimeType(conteudo)) {
                _audios.push(conteudo);
              } else {
                _imgs.push({ src: item.conteudo });
              }
            }

          }
          setImages(_imgs);
          setAudios(_audios);
        }
      }

      setLoading(false)
    } catch (error) {
      setLoading(false);
      throw new Error("Erro ao recuperar anexos: " + error)
    }
  }


  function detectMimeType(b64: string) {
    const signatures: any = {
      JVBERi0: "application/pdf",
      R0lGODdh: "image/gif",
      R0lGODlh: "image/gif",
      iVBORw0KGgo: "image/png",
      "/9j/": "image/jpg"
    };
    for (const s in signatures) {
      if (b64.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  }


  if (!show) return null

  return (
    <>
      <Container>
        <ContainerPath>
          <Title className='!text-white !text-[1rem] !tracking-[1.2px]'>Ocorrência #{ocorrencia?.ocorrencia}</Title>
          <CloseButton handleClose={close} color={theme.colors.white} size={22} />
        </ContainerPath>
        <Content>
          <SectionTop>
            <div>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Data da ocorrência:</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>{moment(ocorrencia?.dataOcorrencia.replace("Z", "")).format("DD/MM/YYYY")}</Text>
            </div>

            <div>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Motivo:</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>{ocorrencia?.motivo}</Text>
            </div>

            <div>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Situação:</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>{ocorrencia?.situacao}</Text>
            </div>

            <div>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Local:</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>{ocorrencia?.localServico}</Text>
            </div>
          </SectionTop>

          <Separator />

          <Section>
            {ocorrencia.descricaoOcorrencia && <div>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Descrição do Colaborador</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>
                {ocorrencia?.descricaoOcorrencia}
              </Text>
            </div>}


            {ocorrencia.descricaoEmpresa && <div style={{ marginTop: 30 }}>
              <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Descrição da Empresa</Subtitle>
              <Text className='!text-[.875rem] !leading-6'>{ocorrencia?.descricaoEmpresa}</Text>
            </div>}
          </Section>

          <Separator />




          <Section>
            <Subtitle className='!text-[.875rem] !mb-2 !font-[550]'>Anexos</Subtitle>
            {loading && <Text className='!text-[.875rem] !text-[rgba(0,0,0,.3)]'>Carregando anexos ...</Text>}
            {!loading && (images.length === 0 && audios.length === 0) && <Text className='!text-[.875rem] !text-[rgba(0,0,0,.3)]'>Ocorrência sem anexo</Text>}
            <LightBoxGallery data={images} />
            {
              audios?.map(i => {
                return <ReactAudioPlayer src={`data:audio/mp4;base64,${i}`} controls />
              })
            }
          </Section>
        </Content>
      </Container>
    </>
  )
}

export default OcorrenciaDetalhe;